import {Component, OnInit} from '@angular/core';
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";
import {CommonService} from "../../common/common.service";

@Component({
  selector: 'pbc-user-needs',
  templateUrl: './user-needs.component.html',
  styleUrls: ["./user-needs.component.scss"]
})
export class UserNeedsComponent implements OnInit {

  constructor(private breadcumbsService: BreadcumbsService, private commonService : CommonService) { }

  ngOnInit() {
    setTimeout(()=>this.breadcumbsService.setSubfolder.emit('Kalkulator Potrzeb Klientów'),100);
  }

  onAskForOfferClick() {
    this.commonService.registerClickOnElement('clickOnAskForOffer','externalServices', 'KALKULATOR POTRZEB KLIENTÓW', null).subscribe(
      success => {
        if (success.status != 1)
          console.log(success.message);
      },
      error => {
        console.log(error);
      }
    );
  }

}
